import { render, staticRenderFns } from "./ASorItemModuleDatapoint.vue?vue&type=template&id=11921fa7"
import script from "./ASorItemModuleDatapoint.vue?vue&type=script&lang=js"
export * from "./ASorItemModuleDatapoint.vue?vue&type=script&lang=js"
import style0 from "./ASorItemModuleDatapoint.vue?vue&type=style&index=0&id=11921fa7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports